<template>
	<div>
		<section class="table-top-pannel cl-container" >
			<section class="cl-xs2">
				<NiceDatetime
					v-model="dateRange"
					range
					only-date
					:format="dateFormat"
					:formatted="dateFormatted"
					:placeholder="$t('common.time_period_placeholder') | capitalize"
					class="datetime-range"
				/>
			</section>

			<NiceButton2
				v-if="downloadReportUrl"
				class="download-button"
				@click="downloadReport"
			>{{ $t('ssp.download_device_report') }}</NiceButton2>
		</section>

		<table
			v-if="devices.length > 0"
			class="nice-table"
		>
			<thead>
				<tr>
					<th>{{ $t('documents.start_date') | capitalize }}</th>
					<th>{{ $t('documents.end_date') | capitalize }}</th>
					<th>{{ $t('documents.device_id') | capitalize }}</th>
					<th>{{ $t('documents.active_time') | capitalize }}</th>
					<th>{{ $t('documents.earnings') | capitalize }}</th>
					<th>&nbsp;</th>
				</tr>
			</thead>

			<tbody>
				<tr
					v-for="device in devices"
					:key="device.id"
				>
					<td>{{ device.start_date }}</td>
					<td>{{ device.end_date }}</td>
					<td>{{ device.name }}</td>
					<td>{{ device.active_time | formatNumber }}</td>
					<td>{{ device.earnings | formatNumber }}</td>
				</tr>
			</tbody>
		</table>
		<div
			v-else-if="!dateRange.start || !dateRange.end"
			class="no-data"
		>Please, select date range</div>
		<div
			v-else
			class="no-data"
		>No data</div>

		<TablePaginator
			v-model="pagination"
			:total="totalCount"
			:paginator-props="{ queryKey: 'p' }"

			@input="handlePaginationChange"
		/>
	</div>
</template>


<script>
// import { mapState, /*mapActions, mapMutations*/ } from 'vuex';

import {
	getPerDeviceEarningsReport,
} from '@/api/billing';

import NiceButton2 from '@/ui/nice-button-2';
import NiceDatetime from '@/ui/nice-datetime';
import TablePaginator from '@/components/table-paginator';


export default {
	name: 'FlasterAdTimeMoneyPerDevice',


	components: {
		NiceButton2,
		NiceDatetime,
		TablePaginator,
	},


	props: {
		/**
		 * Format for NiceDatetime
		 */
		dateFormat: {
			default: 'YYYY-MM-DD',
		},
		dateFormatted: {
			default: 'D MMM`YY',
		},
	},


	data() {
		return {
			dateRange: {
				start: null,
				end: null,
			},

			devices: [],
			totalCount: 0,
			pagination: {
				page: 1,
				pageSize: 20,
			},
			downloadReportUrl: null,
		};
	},


	async mounted() {
		await this.updateReport();
	},


	watch: {
		dateRange: {
			deep: true,
			async handler(range) {
				await this.updateReport();
			}
		},
	},


	methods: {
		downloadReport() {
			if (!this.downloadReportUrl) {
				return;
			}

			const ancor = document.createElement('a');
			ancor.href = this.downloadReportUrl;
			ancor.setAttribute('download', '');
			ancor.className = 'visuallyhidden';
			ancor.tabIndex = -1;
			document.body.appendChild(ancor);
			ancor.click();
			document.body.removeChild(ancor);
		},


		/**
		 * Update report but only if start and end dates are set
		 */
		async updateReport() {
			if (!this.dateRange.start || !this.dateRange.end) {
				return;
			}

		  let payload = {
				page: this.pagination.page,
				page_size: this.pagination.pageSize,
				date_from: this.dateRange.start,
				date_till: this.dateRange.end,
			};

			const devices = await this.fetchPerDeviceReport(payload);

			this.$set(this, 'devices', Object.freeze(devices.results));
			this.totalCount = devices.count;
			this.downloadReportUrl = devices.meta.report_excel_url;
		},

		async fetchPerDeviceReport(payload) {
			let response = null;
			try {
				response = await getPerDeviceEarningsReport(payload);
			}
			catch (error) {
				const resp = error.response;

				this.$log.error(`Error ${resp && resp.status}. Failed to get per device report.`, resp);

				this.error = Object.freeze({
					status: resp.status,
					statusText: resp.status,
					data: resp.data,
				});

				throw error;
			}

			this.error = null;
			return response;
		},

		handlePaginationChange({ page=1, pageSize=20 }={}) {
			this.$set(this, 'pagination', { page, pageSize });
			this.updateReport();
		},

	},  // END: methods
};
</script>

<style lang="sass" scoped >
.download-button
	margin-left: 20px

.no-data
	margin: 20px 20px 20px 0
</style>
